import PropTypes from 'prop-types'

import {useDateFormat} from '@adv-mt/mt-hook-use-date-format'

export const DatePublished = ({date}) => {
  const {numeric: parsedDate} = useDateFormat(date)

  return (
    <time data-testid={`publish-date-${date}`} dateTime={parsedDate}>
      {parsedDate}
    </time>
  )
}

DatePublished.propTypes = {
  date: PropTypes.string.isRequired
}
